<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,0C8.24,0,6,2.24,6,5C6,6.02,6.31,6.96,6.83,7.75C6.83,7.75,0.29,14.29,0.29,14.29C0.11,14.47,0,14.72,0,15C0,15.55,0.45,16,1,16C1.28,16,1.53,15.89,1.71,15.71C1.71,15.71,3,14.41,3,14.41C3,14.41,4.29,15.7,4.29,15.7C4.47,15.89,4.72,16,5,16C5.28,16,5.53,15.89,5.71,15.71C5.71,15.71,7.71,13.71,7.71,13.71C7.89,13.53,8,13.28,8,13C8,12.72,7.89,12.47,7.71,12.29C7.71,12.29,6.41,11,6.41,11C6.41,11,8.24,9.17,8.24,9.17C9.04,9.69,9.98,10,11,10C13.76,10,16,7.76,16,5C16,2.24,13.76,0,11,0C11,0,11,0,11,0ZM11,8C10.77,8,10.55,7.97,10.34,7.92C10.33,7.92,10.32,7.91,10.31,7.91C10.1,7.86,9.9,7.79,9.71,7.7C9.09,7.4,8.6,6.91,8.3,6.29C8.21,6.1,8.14,5.9,8.09,5.7C8.09,5.69,8.08,5.68,8.08,5.67C8.03,5.45,8,5.23,8,5C8,3.34,9.34,2,11,2C12.66,2,14,3.34,14,5C14,6.66,12.66,8,11,8C11,8,11,8,11,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Key',
} as DefineComponent
</script>
